import React from "react";

// given a value will return a previous value, to be used inside a useEffect
export const usePrevious = <T,>(value: T) => {
    const ref = React.useRef<T>();

    React.useEffect(() => {
        ref.current = value;
    }, [value]); // only re-run if value changes

    // return previous value (happens before update in useEffect above)
    return ref.current;
};
